(function ($) {
  $(document).ready(function () {
    $(".with-tabs .selected").on("click", function () {
      $(this).closest(".tabs-wrap").toggleClass("active");
      var hasActiveClass = $(this).closest(".tabs-wrap").hasClass("active");
      if (hasActiveClass === false) {
        var currentSelectbox = $(this).find(".text").text().trim();
        $.each($(".tabs-wrap ul li.tab"), function () {
          var selectbox = $(this).text().trim();
          if (selectbox === currentSelectbox) $(this).addClass("active");
          else $(this).removeClass("active");
        });
      }
    });
    $(window).on("resize orientationchange", function () {
      $(".with-tabs .tabs-wrap").removeClass("active");
    });

    $(".with-tabs ul li.tab").on("click", function () {
      var listText = $(this).children('h3').text();
      $(this).parent().parent().find(".selected").empty();
      $(this).parent().parent().find(".selected").append('<span class="text">' + listText + '</span>');
      $(this).parent().parent().removeClass("active");
    });
  });
})(jQuery);